import Enum from './Enum'

class DebugSocketStateEnum extends Enum {
  constructor() {
    super()
    this.OPENED = 0
    this.CLOSED = 1
  }
}

export default Object.freeze(new DebugSocketStateEnum())
